<template>
  <TextBlob>
    <template #heading> Register </template>
    <template #text>
      <div v-if="emailRegister" class="text-center">
        To register, please enter your email and password below.
        <br />
        <br />
        <div class="flex flex-col w-full justify-center items-center">
          <div class="flex w-full md:w-2/3 justify-center" v-for="(field, key) in fields" :key="key">
            <div class="md:w-2/3 p-2">
              <el-input v-model="field.value" :placeholder="field.placeholder" :type="field.type" style="width: 100%"
                @keydown.enter.prevent="submitRegister">
                <template #prepend>
                  <span class="font-bold w-[110px] text-right">{{ key }}</span>
                </template>
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full h-full flex justify-center items-center">
        <div class="w-2/3 flex flex-col justify-evenly h-full">
          <div class="flex justify-center">
            <el-button :class=registerButtons type="success" size="large" plain @click="submitRegister"
              :disabled="registering">
              <PulseLoader v-if="registering" />
              <div v-else>Submit</div>
            </el-button>
          </div>
          <div class="flex justify-center">
            <el-button :class=registerButtons type="primary" size="large" plain
              @click="emailRegister = false; userStore.activeRoute = 'login'">Back to Login</el-button>
          </div>
        </div>
      </div>
      <LoginError :error="errorMessage" />
    </template>
  </TextBlob>
</template>

<script setup>
import TextBlob from "@/components/TextBlob.vue";
import { ref, watch } from "vue";
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import router from "@/router";
import { useUser } from '@/stores';
const userStore = useUser()
import api from "@/composables/api";
import LoginError from "./LoginError.vue";
import { useError } from "@/composables/useError";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

const registerButtons = "mt-4 w-2/3"
const emailRegister = ref(true)
const { errorMessage, processError } = useError();
const registering = ref(false);
const fields = ref({
  'Email': { value: '' },
  'Password': { value: '', type: 'password' },
  'Confirm Password': { value: '', type: 'password' },
  'First Name': { value: '' },
  'Last Name': { value: '' },
  'Company': { value: '' },
  'Phone Number': { value: '' },
  'Address': { value: '' },
});

// const loginRoute = () => {
//   store.activeRoute = "login"
//   router.push("/login")
// }

const submitRegister = async () => {
  if (!fields.value['Confirm Password'].value || (fields.value['Password'].value !== fields.value['Confirm Password'].value)) {
    processError({
      code: "auth/passwords-don't-match",
    });
    return;
  }

  registering.value = true;
  const auth = getAuth();

  try {
    const userCredential = await createUserWithEmailAndPassword(auth, fields.value['Email'].value, fields.value['Password'].value);
    const user = userCredential.user;
    userStore.user = user;

    const response = await api("v1/user/create", {
      method: "POST",
      body: {
        email: fields.value['Email'].value,
        firstName: fields.value['First Name'].value,
        lastName: fields.value['Last Name'].value,
        company: fields.value['Company'].value,
        phoneNumber: fields.value['Phone Number'].value,
        address: fields.value['Address'].value,
      },
    });

    await sendEmailVerification(auth.currentUser);

    userStore.isUserLoaded = true;
    router.push("/explorer/dashboard");

  } catch (error) {
    processError(error);
  } finally {
    registering.value = false;
  }
}


// const submitRegister = () => {
//   if (!fields.value['Confirm Password'].value || (fields.value['Password'].value !== fields.value['Confirm Password'].value)) {
//     processError({
//       code: "auth/passwords-don't-match",
//     });
//     return;
//   }
//   registering.value = true;

//   const auth = getAuth();
//   try {
//     createUserWithEmailAndPassword(auth, fields.value['Email'].value, fields.value['Password'].value)
//       .then((userCredential) => {
//         console.log("userCredential", userCredential)
//         const user = userCredential.user;
//         userStore.user = user

//         // create user in db{}
//         api("v1/user/create", {
//           method: "POST",
//           body: {
//             email: fields.value['Email'].value,
//             firstName: fields.value['First Name'].value,
//             lastName: fields.value['Last Name'].value,
//             company: fields.value['Company'].value,
//             phoneNumber: fields.value['Phone Number'].value,
//             address: fields.value['Address'].value,
//           },
//         })
//           .then((response) => {
//             console.log("create user response", response)
//             sendEmailVerification(auth.currentUser)
//               .then(() => {
//                 console.log("email sent")
//                 userStore.isUserLoaded = true
//                 router.push("/explorer/dashboard")
//               }).catch((error) => {
//                 console.log("email error")
//                 processError(error);
//                 registering.value = false;
//               });
//           })
//           .catch((error) => {
//             console.log("user create error", error)
//             processError(error);
//             registering.value = false;
//           }
//           );
//       })
//       .catch((error) => {
//         processError(error);
//         registering.value = false;
//         // router.push("/error")
//       })
//   }
//   catch (error) {
//     // console.log("error", error)
//     processError(error);
//   }
// }

// const buttons = ref([
//   { text: 'Register with Email', type: 'primary', action: () => (emailRegister.value = true) },
//   { text: 'Submit', type: 'success', action: submitRegister },
//   { text: 'Back to Login', type: 'primary', action: loginRoute }
// ]);
</script>
<style>
/* .required-field::after {
  content: "*";
  color: red;
} */
</style>
